import Vue from 'vue'
import VueRouter from 'vue-router'
import AccountManage from '../views/AccountManageEx.vue'
import DepartmentManage from '../views/DepartmentManage.vue'
import RoleManage from '../views/RoleManageEx.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'AccountManageEx',
    component: AccountManage
  },
  {
    path: '/DepartmentManage',
    name: 'DepartmentManage',
    component: DepartmentManage
  },
  {
    path: '/RoleManageEx',
    name: 'RoleManageEx',
    component: RoleManage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
